import { commonActionTypes } from "../actionTypes/commonPdfActionTypes";
import { createAction } from "@reduxjs/toolkit";

export const discardAction = createAction(commonActionTypes.discard);
